import { css } from 'aphrodite';
import { ModalWrapper } from 'components/ModalWrapper/ModalWrapper';
import React, { FC, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { isExhibitorUser } from 'redux/reducers/user';
import { RootState } from 'redux/store';
import { checkIfTrue } from 'util/helpers';
import { SurveyIcon } from 'util/icons';
import { readFromStorage, removeFromStorage, writeToStorage } from 'util/storage';
import { hasSurveyBeenSubmittedByUser } from 'util/survey-helpers';
import { style } from './style';

export const SurveyAvailableModal: FC<{}> = () => {
  const styles = style();
  const history = useHistory();
  const userData = useSelector((state: RootState) => state.user.data);
  const cmsData = useSelector((state: RootState) => state.widget.cms.text.survey_available_notification);
  const isExhibitor = useSelector(isExhibitorUser);

  const checkIfModalShouldShow = useCallback((): boolean => {
    const isUserLoggedIn = !!userData;
    if (!isUserLoggedIn) removeFromStorage(cmsData.localstorage_key);
    const showChatAvailableModal = checkIfTrue(cmsData.show_notification);
    const hasAlreadyBeenShownedWhileLoggedin = isUserLoggedIn && readFromStorage(cmsData.localstorage_key);
    const hasSurveyBeenSubmitted = !!userData && hasSurveyBeenSubmittedByUser(userData);

    return (
      isUserLoggedIn &&
      showChatAvailableModal &&
      !hasAlreadyBeenShownedWhileLoggedin &&
      !hasSurveyBeenSubmitted &&
      !isExhibitor
    );
  }, [cmsData.localstorage_key, cmsData.show_notification, isExhibitor, userData]);

  useEffect(() => {
    setOpen(checkIfModalShouldShow());
  }, [userData, cmsData, checkIfModalShouldShow]);

  const onConfirmation = () => {
    history.push('/survey');
  };

  const onClose = () => {
    writeToStorage(cmsData.localstorage_key, true);
    setOpen(false);
  };

  const [buttonRef, setButtonRef] = useState<HTMLButtonElement | null>();
  const [open, setOpen] = useState<boolean>(checkIfModalShouldShow());

  return (
    <ModalWrapper
      isOpen={open}
      onRequestClose={() => onClose()}
      onConfirmation={() => {
        onConfirmation();
      }}
      confirmationButtonRef={buttonRef}>
      <div className={css(styles.container)}>
        <h1 className={css(styles.headline)}>{cmsData.title}</h1>
        <div className={css(styles.icon)}>
          <SurveyIcon></SurveyIcon>
        </div>
        <div className={css(styles.message)} dangerouslySetInnerHTML={{ __html: cmsData.description }}></div>
        <button className={css(styles.button)} ref={(el) => setButtonRef(el)}>
          {cmsData.button_text}
        </button>
      </div>
    </ModalWrapper>
  );
};
